import { Box } from '@chakra-ui/react';
import IframeResizer from 'iframe-resizer-react';

function IFrameViewer({ url }: { url: string }) {
  return (
    <Box
      w="100%"
      h="100%"
      minH="700px"
      bg="white"
      borderRadius="2xl"
      boxShadow="lg"
      overflow="hidden"
    >
      <IframeResizer
        src={url}
        style={{ height: '1px', width: '1px', minHeight: '100%', minWidth: '100%' }}
      />
    </Box>
  );
}

export default IFrameViewer;
